import { defineStore } from 'pinia';

export const useDateStore = defineStore('date', () => {
    // #region DATE

    function toISODate(date) {
        return date.toISOString().split('T').first();
    }

    function addDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    function subtractDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() - days);
        return result;
    }

    function addMonths(date, months) {
        const result = new Date(date);
        result.setMonth(result.getMonth() + months);
        return result;
    }

    function subtractMonths(date, months) {
        const result = new Date(date);
        result.setMonth(result.getMonth() - months);
        return result;
    }

    function addYears(date, years) {
        const result = new Date(date);
        result.setFullYear(result.getFullYear() + years);
        return result;
    }

    function subtractYears(date, years) {
        const result = new Date(date);
        result.setFullYear(result.getFullYear() - years);
        return result;
    }

    function getDaysDifference(date1, date2) {
        const diff = Math.abs(date1.getTime() - date2.getTime());
        return Math.ceil(diff / (1000 * 3600 * 24));
    }

    function getMonthsDifference(date1, date2) {
        const diff = Math.abs(date1.getTime() - date2.getTime());
        return Math.ceil(diff / (1000 * 3600 * 24 * 30));
    }

    function getYearsDifference(date1, date2) {
        const diff = Math.abs(date1.getTime() - date2.getTime());
        return Math.ceil(diff / (1000 * 3600 * 24 * 365));
    }

    // #endregion

    return {
        // date
        toISODate,
        addDays,
        subtractDays,
        addMonths,
        subtractMonths,
        addYears,
        subtractYears,
        getDaysDifference,
        getMonthsDifference,
        getYearsDifference,
    };
});
